import { createAbby } from '@tryabby/next';
import { ABBY_FEATUREFLAGS, ABBY_REMOTECONFIGS } from '@icommerce/feature-flags';
import getConfig from 'next/config';
import type { NextRuntimeConfiguration } from '@hub/libs/config';
import { EnvironmentName } from '@hub/libs/constants';

const { publicRuntimeConfig } = getConfig() as NextRuntimeConfiguration;

export const {
  __abby__: abby,
  AbbyProvider,
  useFeatureFlag,
  withAbby,
  withAbbyApiHandler,
  getFeatureFlagValue,
  getRemoteConfig,
  withDevtools,
} = createAbby({
  projectId: publicRuntimeConfig.abbyProjectId,
  currentEnvironment:
    publicRuntimeConfig.envName === EnvironmentName.AWS || publicRuntimeConfig.envName === EnvironmentName.LOCAL
      ? EnvironmentName.WHITE
      : publicRuntimeConfig.envName,
  environments: [EnvironmentName.BLACK, EnvironmentName.WHITE, EnvironmentName.ORANGE],
  tests: {},
  flags: [...ABBY_FEATUREFLAGS],
  remoteConfig: ABBY_REMOTECONFIGS,
  settings: {
    flags: {
      devOverrides: {
        // turns ON all featureflags by default in DEV mode
        ...Object.fromEntries(ABBY_FEATUREFLAGS.map(key => [key, true])),
        // overwrite certain featureflags
        useNewHeaderLanguageSwitcher: false,
      },
    },
  },
});
